import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

import { ConfiguratorRenewalInformation } from '@models';
import { PostRenewalInformationParams } from './service';

export enum PostRenewalInformationActions {
  Failure = '[Configurator PostRenewalInformation] Failure',
  Request = '[Configurator PostRenewalInformation] Request',
  Success = '[Configurator PostRenewalInformation] Success',
}

export const PostRenewalInformationFailure = createAction(
  PostRenewalInformationActions.Failure,
  props<{ error: HttpErrorResponse }>()
);

export const PostRenewalInformationRequest = createAction(
  PostRenewalInformationActions.Request,
  props<{ body: ConfiguratorRenewalInformation; parameters?: PostRenewalInformationParams }>()
);

export const PostRenewalInformationSuccess = createAction(
  PostRenewalInformationActions.Success,
  props<{ data: ConfiguratorRenewalInformation }>()
);
